import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios'
import { makeStyles } from '@material-ui/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  controlLabel: {
    width: 300
  },
  formControl: {
    marginTop: 20
  }
}));

const TypePersonData = props => {
  const classes = useStyles();
  const { className, financeuser, getTypePersonValue } = props;
  const [typePersonData, setTypePersonData] = useState([]);  // select data from database
  const [values, setValues] = useState([]);
  const [state, setState] = useState({});
  let source = axios.CancelToken.source();

  useEffect(() => {
    fetchData();
    getFinanceUser(financeuser);
    return () => {
      source.cancel();
    };
  }, [financeuser]);

  const fetchData = async () => {
    const url = 'https://eslip.snru.ac.th/backend/api/users/typepersons';
    try {
      const result = await axios(url, {
        cancelToken: source.token
      });
      setTypePersonData(result.data.data);
      console.log(result.data.data)
    } catch (error) { 
      console.log(error);
    }
  };

  const getFinanceUser = async person => {
    let obj = {};
    let obj2 = {};
    const url = 'https://eslip.snru.ac.th/backend/api/financeTypePerson/' + person.value;
    try {
      const response = await axios.get(url, {
        cancelToken: source.token
      });
      response.data.data.map(element => {
        obj = { ...obj, [element.type_person_id]: true }
        obj2 = { ...obj2, [element.type_person_id]: element.type_person_id.toString() }
      });
      console.log(response.data.data)
      setState({ ...state, ...obj });
      
      const result = Object.values(obj2);

      setValues(result);
      getTypePersonValue(result);
    } catch (error) { 
      console.log(error)
    }
  }

  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
    const index = values.indexOf(event.target.value);
    (event.target.checked) ? (values.push(event.target.value)) : (values.splice(index, 1))
    getTypePersonValue(values);
  };

  return (
    <div className={classes.root}>
      <FormControl component="fieldset">
        <FormLabel component="legend"><h3>ประเภทบุคลากร</h3></FormLabel>
        <FormGroup aria-label="position" name="position" row>
          {
            typePersonData.map((TypePerson, i) =>
              <FormControlLabel key={i} className={classes.controlLabel}
                control={
                  <Checkbox
                    checked={state[TypePerson.type_person_id]||false}
                    onChange={handleChange(TypePerson.type_person_id)}
                    value={TypePerson.type_person_id}
                    color="primary"
                  />
                }
                label={TypePerson.type_person_name}
              />)
          }
        </FormGroup>
      </FormControl>
    </div>
  );
};

TypePersonData.propTypes = {
  className: PropTypes.string,
  TypePerson: PropTypes.object,
  financeuser: PropTypes.object,
  getTypePersonValue: PropTypes.func
};

export default TypePersonData;